var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"transition-slide-right"}},[(!!_vm.orderDetail)?_c('Detail'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }